import { configureStore } from '@reduxjs/toolkit';
import { cartReducer } from './cart/cart.slice';
import { searchReducer } from './search/search.slice';
import { appReducer } from './app/app.slice';

export const store = configureStore({
  reducer: { cart: cartReducer, search: searchReducer, app: appReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
